import gql from "graphql-tag";

export type GameFragment = {
  id: string;
  white: {
    id: string;
    name: string;
  };
  black: {
    id: string;
    name: string;
  };
  createdAt: string;
  updatedAt: string;
  epd: string;
  legalMoves: string[] | null;
  lastEpd: string | null;
  lastMove: string | null;
  availableDuels: string[] | null;
  toAct: string | null;
  nextAction?: "move" | "offer_duel" | "resolve_duel";
  pendingDuelBid?: number;
  winner: string | null;
};

export const gameFragment = gql`
  fragment Game on Game {
    id
    white {
      id
      name
    }
    black {
      id
      name
    }
    createdAt
    updatedAt
    epd
    legalMoves
    lastEpd
    lastMove
    availableDuels
    toAct
    nextAction
    pendingDuelBid
    winner
  }
`;

export type GameQuery = {
  game?: GameFragment;
};

export const gameQuery = gql`
  query gameQuery($id: ID!) {
    game(id: $id) {
      ...Game
    }
  }

  ${gameFragment}
`;

export const gameMove = gql`
  mutation gameMove($id: ID!, $uci: String!) {
    gameMove(id: $id, uci: $uci) {
      ...Game
    }
  }

  ${gameFragment}
`;

export const gameStartDuel = gql`
  mutation gameStartDuel($id: ID!, $duelNumber: Int!, $bid: Int!) {
    gameStartDuel(id: $id, duelNumber: $duelNumber, bid: $bid) {
      ...Game
    }
  }

  ${gameFragment}
`;

export const gameSkipDuel = gql`
  mutation gameSkipDuel($id: ID!, $duelNumber: Int!) {
    gameSkipDuel(id: $id, duelNumber: $duelNumber) {
      ...Game
    }
  }

  ${gameFragment}
`;

export const gameResolveDuel = gql`
  mutation gameResolveDuel($id: ID!, $bid: Int!, $gain: Boolean) {
    gameResolveDuel(id: $id, bid: $bid, gain: $gain) {
      ...Game
    }
  }

  ${gameFragment}
`;

export const gameResign = gql`
  mutation gameResign($id: ID!) {
    gameResign(id: $id) {
      ...Game
    }
  }

  ${gameFragment}
`;
